<div>
  <div class="p-4">
    <div class="d-flex justify-content-end align-items-center">
      <div class="col">
        <h6 class="m-0 font-size-20">알람</h6>
      </div>
      <button (click)="modalClose()" class="btn btn-hover-bg">
        <i class="bx bx-x font-size-24"></i>
      </button>
    </div>
  </div>

  <div class="d-flex justify-content-end align-items-center pr-4 pl-4 pb-3">
    <button (click)="allRead()" class="btn btn-txt small mr-2" type="button">모두 읽기</button>
    <button (click)="allDelete()" class="btn btn-txt small" type="button">전체 삭제</button>
  </div>

  <div class="list-none">
    <p class="text-muted">등록된 알림이 없습니다.</p>
  </div>

  <div style="position: relative; min-height: 230px" class="pb-4">
    <a href="" class="text-reset notification-item">
      <div class="media">
        <div class="media-body">
          <div class="alarm-tit-wrap mb-1">
            <h6 class="mt-0">알람 제목</h6>
            <span class="new-badge">NEW</span>
          </div>

          <p class="mb-0 font-size-12 text-muted">
            {{ ' 2024 / 10 / 11' | date : 'yy.MM.dd' }}
          </p>
        </div>
      </div>
    </a>
  </div>
</div>
